module.exports = __webpack_public_path__ + "img/e49f11b.svg";